import { useEffect, useRef, useCallback } from 'react';
import { ForceSimulation } from '../forceSimulation';
import { ForceGraphData, ForceGraphConfig } from '../config/forceGraphTypes';

export const useForceSimulation = (
    data: ForceGraphData,
    config: ForceGraphConfig,
    width: number,
    height: number,
    onTick: () => void
) => {
    const simulationRef = useRef<ForceSimulation | null>(null);

    // Initialize Simulation
    useEffect(() => {
        if (!simulationRef.current) {
            simulationRef.current = new ForceSimulation(onTick);
        }
        return () => {
            simulationRef.current?.stop();
        };
    }, []); // Run once

    // Update Data
    useEffect(() => {
        if (simulationRef.current && data.nodes.length > 0) {
            simulationRef.current.updateData(data);
        }
    }, [data]);

    // Update onTick
    useEffect(() => {
        if (simulationRef.current) {
            simulationRef.current.setOnTick(onTick);
        }
    }, [onTick]);

    // Update Config & Dimensions
    useEffect(() => {
        if (simulationRef.current) {
            simulationRef.current.updateConfig(config, width, height);
        }
    }, [config, width, height]);

    return simulationRef.current;
};
